import React from 'react';
import { Create } from 'react-admin';
import SectorForm from '../SectorForm';

function SectorCreate(props) {
  return (
    <Create {...props}>
      <SectorForm redirect="list" />
    </Create>
  );
}

export default SectorCreate;
